import axios from "../axiosInstance";
import {
  ApproveEmailNotificationRequest,
  ApproveEmailNotificationResponse,
} from "./types";

export const approveEmailNotification = async (
  payload: ApproveEmailNotificationRequest,
): Promise<ApproveEmailNotificationResponse> => {
  const response = await axios.post<ApproveEmailNotificationResponse>(
    "/api/private/email-notifications/approve",
    payload,
  );
  return response.data;
};
